import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import { CHAMBER_MEMBERS } from '../data/chamberMembers';
import './BusinessDirectory347.css';

const CHAMBER_DIRECTORY_URL = 'https://www.maricopachamber.org/directory';

const BASE_DIRECTORY_LISTINGS = [
  {
    id: 'sandy-hopkins-realtor',
    name: `${SITE_CONFIG.AGENT.NAME} — Realtor`,
    monogram: 'SH',
    category: 'Real Estate',
    location: 'Maricopa, Arizona',
    description: `Local guidance for buying, selling, and relocating in Maricopa and nearby Arizona communities with ${SITE_CONFIG.AGENT.NAME}.`,
    phone: SITE_CONFIG.AGENT.PHONE,
    email: SITE_CONFIG.AGENT.EMAIL,
    website: `https://${SITE_CONFIG.BASE_URL}`,
    services: ['Home buying', 'Home selling', 'Relocation guidance']
  },
  {
    id: 'honeycutt-coffee-cafe',
    name: 'Honeycutt Coffee Cafe & Wine Bar',
    monogram: 'HC',
    category: 'Food & Drink',
    location: '44400 Honeycutt Rd, Maricopa, AZ',
    description: 'A neighborhood cafe serving specialty coffee, breakfast and lunch items, pastries, and an evening wine selection.',
    phone: '(520) 510-4468',
    website: 'https://www.honeycuttcoffeecafe.com/',
    services: ['Coffee and tea', 'Breakfast and lunch', 'Wine bar']
  },
  {
    id: 'dukes-roadhouse',
    name: "Duke's Roadhouse",
    monogram: 'DR',
    category: 'Food & Drink',
    location: '19395 N John Wayne Pkwy, Maricopa, AZ 85139',
    description: 'A two-story Maricopa restaurant and entertainment venue with dining, live music, dancing, and indoor and outdoor gathering spaces.',
    phone: '(520) 213-8005',
    website: 'https://dukesroad.house/',
    services: ['Dining and drinks', 'Live music', 'Dancing and events']
  },
  {
    id: 'mandys-wine-bar',
    name: "Mandy's Wine Bar",
    monogram: 'MW',
    category: 'Food & Drink',
    location: '41600 W Smith Enke Rd, Suite 120, Maricopa, AZ',
    description: 'A locally owned wine bar and restaurant offering Mediterranean-inspired dishes, weekend brunch, and private-event options.',
    phone: '(520) 728-4248',
    website: 'https://www.mandyswinebar.com/',
    services: ['Wine and cocktails', 'Lunch and dinner', 'Weekend brunch']
  },
  {
    id: 'nandos-mexican-cafe',
    name: "Nando's Mexican Cafe",
    monogram: 'NM',
    category: 'Food & Drink',
    location: '44460 W Edison, Maricopa, AZ',
    description: 'A locally operated Mexican cafe serving dine-in and carry-out meals from its Maricopa location.',
    phone: '(520) 532-1011',
    website: 'https://nandosmexicancafe.com/',
    services: ['Mexican food', 'Carry-out', 'Catering']
  },
  {
    id: 'plaza-bonita-maricopa',
    name: 'Plaza Bonita Family Mexican Restaurant',
    monogram: 'PB',
    category: 'Food & Drink',
    location: '21141 N John Wayne Pkwy, Maricopa, AZ',
    description: 'A family Mexican restaurant with a full menu, takeout, and a full bar at its Maricopa location.',
    phone: '(520) 568-4148',
    website: 'https://www.plazabonitaaz.com/',
    services: ['Mexican food', 'Takeout', 'Full bar']
  },
  {
    id: 'the-slab-premium-meats',
    name: 'The Slab Premium Meats',
    monogram: 'TS',
    category: 'Shopping',
    location: '44870 W Hathaway Ave, Suite 2, Maricopa, AZ',
    description: 'A locally owned butcher shop offering fresh beef, pork, poultry, game meats, house-made sausages, and specialty cuts.',
    phone: '(520) 509-4630',
    website: 'https://theslabpremiummeats.com/',
    services: ['Fresh meats', 'Specialty cuts', 'House-made sausages']
  },
  {
    id: 'garden-social',
    name: 'Garden Social Nursery & Garden Center',
    monogram: 'GS',
    category: 'Home & Garden',
    location: '45030 W Edwards Ave, Maricopa, AZ',
    description: 'A locally operated nursery specializing in desert-acclimated plants, garden supplies, soil amendments, and community classes.',
    phone: '(816) 674-0534',
    email: 'Gardensocial@yahoo.com',
    website: 'https://gardensocialaz.com/nursery/',
    services: ['Desert plants', 'Garden supplies', 'Gardening events']
  },
  {
    id: 'karstens-ace-hardware',
    name: "Karsten's Ace Hardware",
    monogram: 'KA',
    category: 'Home & Garden',
    location: '21542 N John Wayne Pkwy, Maricopa, AZ',
    description: 'A locally owned hardware store serving Maricopa with home-improvement supplies, tools, lawn and garden products, and equipment.',
    phone: '(520) 494-7805',
    email: 'Maricopa@karstensace.com',
    website: 'https://www.acehardware.com/store-details/17630',
    services: ['Hardware and tools', 'Lawn and garden', 'Paint and plumbing']
  },
  {
    id: 'maricopa-renovations',
    name: 'Maricopa Renovations',
    monogram: 'MR',
    category: 'Home Services',
    location: '41600 W Smith Enke Rd, Building 2, Suite 110, Maricopa, AZ 85138',
    description: 'A local remodeling team with a Maricopa showroom offering kitchen and bathroom renovations, flooring, countertops, and whole-home interior remodeling.',
    phone: '(520) 895-2672',
    email: 'info@MaricopaRenovations.com',
    website: 'https://maricoparenovations.com/',
    services: ['Kitchen and bathroom remodeling', 'Flooring and countertops', 'Whole-home renovations']
  },
  {
    id: 'maricopa-cleaners',
    name: 'Maricopa Cleaners',
    monogram: 'MC',
    category: 'Home Services',
    location: 'Serving Maricopa, AZ',
    description: 'A locally owned residential and commercial cleaning company serving Maricopa and nearby communities.',
    phone: '(520) 840-1630',
    email: 'Maricopacleaners@gmail.com',
    website: 'https://maricopacleaners.com/',
    services: ['Regular cleaning', 'Deep cleaning', 'Move-in and move-out cleaning']
  },
  {
    id: 'oasis-maricopa-landscapers',
    name: 'Oasis Maricopa Landscapers',
    monogram: 'OM',
    category: 'Home Services',
    location: 'Serving Maricopa, AZ',
    description: 'A locally owned landscaping company offering outdoor design, artificial turf, hardscaping, lighting, and maintenance services.',
    phone: '(520) 341-2984',
    website: 'https://www.maricopalandscapers.com/',
    services: ['Landscape design', 'Artificial turf', 'Hardscaping']
  },
  {
    id: 'maricopa-we-care',
    name: 'Maricopa We Care',
    monogram: 'MW',
    category: 'Health & Care',
    location: '45063 W Jack Rabbit Trl, Maricopa, AZ',
    description: 'An in-home care provider offering personalized support for older adults and families throughout Arizona.',
    phone: '(520) 759-2147',
    email: 'info@maricopawecare.com',
    website: 'https://maricopawecare.com/',
    services: ['Personal care', 'Companionship', 'Respite care']
  },
  {
    id: 'aamco-maricopa',
    name: 'AAMCO Maricopa',
    monogram: 'AM',
    category: 'Automotive',
    location: '20145 N John Wayne Pkwy, Maricopa, AZ',
    description: 'A locally operated automotive service center providing transmission work, maintenance, diagnostics, brakes, and other repairs.',
    phone: '(520) 464-4940',
    website: 'https://www.aamcomaricopa.com/',
    services: ['Transmission service', 'Auto maintenance', 'Diagnostics and repair']
  }
];

const normalizeBusinessName = (name) => name
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]/g, '');

const getMonogram = (name) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((word) => word[0].toUpperCase())
  .join('');

const chamberMembersByName = new Map(
  CHAMBER_MEMBERS.map((member) => [normalizeBusinessName(member.name), member])
);

const enrichedBaseListings = BASE_DIRECTORY_LISTINGS.map((listing) => {
  const chamberMember = chamberMembersByName.get(normalizeBusinessName(listing.name));
  if (!chamberMember) return listing;

  return {
    ...listing,
    isChamberMember: true,
    memberSince: chamberMember.memberSince,
    chamberProfile: chamberMember.chamberProfile
  };
});

const baseListingNames = new Set(
  BASE_DIRECTORY_LISTINGS.map((listing) => normalizeBusinessName(listing.name))
);

const chamberDirectoryListings = CHAMBER_MEMBERS
  .filter((member) => !baseListingNames.has(normalizeBusinessName(member.name)))
  .map((member) => ({
    id: `gmba-${normalizeBusinessName(member.name)}`,
    name: member.name,
    monogram: getMonogram(member.name),
    category: member.category,
    location: member.location,
    description: `${member.name} is listed in the Greater Maricopa Business Alliance's public member directory as a member since ${member.memberSince}. Contact the organization directly to confirm current services and availability.`,
    phone: member.phone,
    website: member.website,
    chamberProfile: member.chamberProfile,
    memberSince: member.memberSince,
    isChamberMember: true,
    services: [member.category, 'Greater Maricopa Business Alliance member']
  }));

const DIRECTORY_LISTINGS = [...enrichedBaseListings, ...chamberDirectoryListings];

const RESOURCE_LINKS = [
  {
    title: 'City business resources',
    description: 'Find licensing information, small-business organizations, and services from the City of Maricopa.',
    url: 'https://www.maricopa-az.gov/Business/Business-Resources',
    label: 'Visit city resources'
  },
  {
    title: 'Economic opportunity',
    description: 'Explore local development and business information from Maricopa’s Office of Economic Opportunity.',
    url: 'https://www.maricopaoeo.com/',
    label: 'Explore local opportunity'
  },
  {
    title: 'Black Maricopa Chamber',
    description: 'Browse another independent source for businesses and community connections in Maricopa.',
    url: 'https://www.blackmaricopacc.com/member-directory',
    label: 'Open member directory'
  },
  {
    title: 'Greater Maricopa Business Alliance',
    description: 'Browse the Alliance’s separate member directory as another way to find businesses in the area.',
    url: CHAMBER_DIRECTORY_URL,
    label: 'Open member directory'
  }
];

const BusinessDirectory347 = () => {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All categories');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const categories = useMemo(
    () => ['All categories', ...new Set(DIRECTORY_LISTINGS.map((listing) => listing.category))],
    []
  );

  const results = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return DIRECTORY_LISTINGS.filter((listing) => {
      const matchesCategory = category === 'All categories' || listing.category === category;
      const searchableText = [
        listing.name,
        listing.category,
        listing.location,
        listing.description,
        listing.isChamberMember ? 'Greater Maricopa Business Alliance GMBA Chamber member' : '',
        ...listing.services
      ].join(' ').toLowerCase();

      return matchesCategory && (!normalizedQuery || searchableText.includes(normalizedQuery));
    });
  }, [category, query]);

  return (
    <main className="directory347-page">
      <div className="directory347-shell">
        <Link className="directory347-back" to="/">← Back to Sandy’s home page</Link>

        <header className="directory347-hero">
          <div className="directory347-hero-copy">
            <span className="directory347-kicker">Independent Maricopa resource</span>
            <h1><em>347</em> Business Directory</h1>
            <p>Find restaurants, shops, home services, care providers, and other businesses serving Maricopa, Arizona.</p>
            <div className="directory347-hero-actions">
              <a href="#local-listings">Browse Maricopa businesses</a>
              <Link className="directory347-action-secondary" to="/347-directory/setup">Add or update a business</Link>
            </div>
          </div>
          <div className="directory347-route-mark" aria-hidden="true">
            <span>AZ</span>
            <strong>347</strong>
            <small>MARICOPA</small>
          </div>
        </header>

        <section className="directory347-trust-note" aria-label="Directory independence notice">
          <strong>Built for everyday local discovery.</strong>
          <p>Listings are compiled from public business information and owner-submitted updates, including all {CHAMBER_MEMBERS.length} organizations in the Greater Maricopa Business Alliance’s public member directory. Inclusion is free and does not imply sponsorship or endorsement. Please confirm hours, services, and availability directly with each business.</p>
        </section>

        <section id="local-listings" className="directory347-listings" aria-labelledby="directory347-listings-heading">
          <div className="directory347-section-heading">
            <div>
              <span>Maricopa, Arizona</span>
              <h2 id="directory347-listings-heading">Find a business</h2>
            </div>
            <p>{results.length} {results.length === 1 ? 'listing' : 'listings'} found</p>
          </div>

          <div className="directory347-search-panel">
            <label>
              <span>Search by name or service</span>
              <input
                type="search"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Try coffee, landscaping, or auto repair"
              />
            </label>
            <label>
              <span>Category</span>
              <select value={category} onChange={(event) => setCategory(event.target.value)}>
                {categories.map((option) => <option key={option}>{option}</option>)}
              </select>
            </label>
          </div>

          <div className="directory347-card-grid" aria-live="polite">
            {results.map((listing) => (
              <article className="directory347-business-card" key={listing.id}>
                <div className="directory347-business-heading">
                  <div className="directory347-business-monogram" aria-hidden="true">{listing.monogram}</div>
                  <div>
                    <span>{listing.category}</span>
                    <h3>{listing.name}</h3>
                    <p>{listing.location}</p>
                    {listing.isChamberMember && (
                      <small className="directory347-member-badge">GMBA member since {listing.memberSince}</small>
                    )}
                  </div>
                </div>
                <p className="directory347-business-description">{listing.description}</p>
                <ul className="directory347-service-list" aria-label={`${listing.name} services`}>
                  {listing.services.map((service) => <li key={service}>{service}</li>)}
                </ul>
                <div className="directory347-business-actions">
                  {listing.phone && <a href={`tel:${listing.phone.replace(/[^\d+]/g, '')}`}>Call {listing.phone}</a>}
                  {listing.website && <a href={listing.website} target="_blank" rel="noopener noreferrer">Visit website ↗</a>}
                  {listing.chamberProfile && <a href={listing.chamberProfile} target="_blank" rel="noopener noreferrer">Chamber profile ↗</a>}
                  {listing.email && <a href={`mailto:${listing.email}`}>Email</a>}
                </div>
              </article>
            ))}
            {results.length === 0 && (
              <div className="directory347-empty">
                <h3>No business matches that search yet.</h3>
                <p>Try another term or suggest a business below.</p>
              </div>
            )}
          </div>
        </section>

        <section className="directory347-resources" aria-labelledby="directory347-resources-heading">
          <div className="directory347-section-heading">
            <div>
              <span>More ways to explore</span>
              <h2 id="directory347-resources-heading">Local business resources</h2>
            </div>
          </div>
          <div className="directory347-resource-grid">
            {RESOURCE_LINKS.map((resource) => (
              <article key={resource.title}>
                <h3>{resource.title}</h3>
                <p>{resource.description}</p>
                <a href={resource.url} target="_blank" rel="noopener noreferrer">{resource.label} ↗</a>
              </article>
            ))}
          </div>
        </section>

        <section id="suggest-a-business" className="directory347-submit" aria-labelledby="directory347-submit-heading">
          <div className="directory347-submit-copy">
            <span className="directory347-kicker">Your next local connection</span>
            <h2 id="directory347-submit-heading">Your business belongs in the conversation.</h2>
            <p>Walk through a few simple steps to send Sandy a 347 Directory addition or update. Review your details, submit your request, then discover the Maricopa Chamber app.</p>
            <p className="directory347-submit-note">Sandy reviews requests before publication. Chamber membership and app services are separate.</p>
          </div>
          <div><Link className="directory347-action-primary" to="/347-directory/setup">Start your directory request →</Link></div>
        </section>

        <footer className="directory347-footer">
          <p><strong>Directory notice:</strong> The 347 Business Directory is independently operated by {SITE_CONFIG.AGENT.NAME}. Business details can change; verify information directly with the business. Inclusion does not imply an endorsement or affiliation.</p>
          <div>
            <Link to="/">Home</Link>
            <Link to="/contact-us">Contact Sandy</Link>
            <a href="https://www.maricopa-az.gov/Business/Business-Resources" target="_blank" rel="noopener noreferrer">City business resources ↗</a>
          </div>
        </footer>
      </div>
    </main>
  );
};

export default BusinessDirectory347;
